import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { scrollToHash } from "@/lib/scroll";

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const goToResults = (e) => {
    e.preventDefault();
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToHash("#results"), 120);
    } else {
      scrollToHash("#results");
    }
  };

  const pageLink = (to, label, testid) => (
    <Link
      key={to}
      to={to}
      data-testid={testid}
      className={location.pathname === to ? "current" : ""}
      onClick={() => setOpen(false)}
    >
      {label}
    </Link>
  );

  return (
    <header className="site-header" data-testid="site-header">
      <div className="wrap">
        <Link to="/" className="wordmark" data-testid="wordmark-link" onClick={() => setOpen(false)}>
          Rhonda <span>Johnson</span>
        </Link>
        <button
          className="nav-toggle"
          data-testid="nav-toggle"
          aria-expanded={open}
          aria-controls="siteNav"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "Close" : "Menu"}
        </button>
        <nav className={`nav${open ? " open" : ""}`} id="siteNav" data-testid="site-nav">
          <button className="nav-link" data-testid="nav-results" onClick={goToResults}>
            Results
          </button>
          {pageLink("/services", "Services", "nav-services")}
          {pageLink("/about", "About", "nav-about")}
          {pageLink("/contact", "Contact", "nav-contact")}
          <Link to="/contact" className="btn btn-primary" data-testid="nav-cta-button" onClick={() => setOpen(false)}>
            Discuss a Challenge
          </Link>
        </nav>
      </div>
    </header>
  );
}

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer">
      <div className="wrap">
        <div data-testid="footer-copy">© {year} Rhonda Johnson. Fractional &amp; interim partnership leadership.</div>
        <div className="footer-links">
          <a href="mailto:info@rhondajohnson.co" data-testid="footer-email-link">Email</a>
          <a href="https://linkedin.com/in/rjohnson3" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link">
            LinkedIn
          </a>
          <Link to="/contact" data-testid="footer-contact-link">Contact</Link>
          <Link to="/privacy" data-testid="footer-privacy-link">Privacy</Link>
        </div>
      </div>
    </footer>
  );
}
